import {Component, Input} from '@angular/core';
import {PublisherStatus, PublisherStatusLabels} from '../../domain/publisher-status.enum';

@Component({
  selector: 'cm-publisher-status-circle-plate',
  template: `
    <cm-publisher-status-circle [status]="status" [showTooltip]="false"></cm-publisher-status-circle>
    <span class="ml-1">{{PublisherStatusLabels[status]}}</span>
  `
})
export class PublisherStatusCirclePlateComponent {

  @Input()
  public status: PublisherStatus;

  public PublisherStatus = PublisherStatus;
  public PublisherStatusLabels = PublisherStatusLabels;

}
